import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-carselDerly",
  "use": "icon-carselDerly-usage",
  "viewBox": "0 0 15.872 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.872 15\" id=\"icon-carselDerly\">\n  <defs>\n    <style>\n      #icon-carselDerly .cls-1 {\n        fill: #435480;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-carselDerly_路径_963\" data-name=\"路径 963\" class=\"cls-1\" d=\"M72,7V18a4,4,0,0,1-4,4H56.128C56.063,22,72,7.038,72,7Z\" transform=\"translate(-56.128 -7)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol